import React, { useEffect } from 'react'
import { CustomDialogTitle } from '../../../../../../Modules/Common/Custom/CustomDialogTitle';
import { Box, Dialog, DialogContent } from '@mui/material';
import { EntriesPerPage } from '../../../../../Model/Table/Table';
import { isNullOrEmpty } from '../../../../../Model/helpers';
import { DataTable } from '../../../DataTable/DataTable';
import { WorkforceProfileOFOCodeTableMapper } from './WorkforceProfileOFOCodeTable';
import { WSPDashboardService } from '../../../../../Api/WSPDashboard/WSPDashboardService';
import { WorkforceProfileOFOCodeSearchInput, WorkforceProfileOFOCodeSummary } from '../../../../../Model/Dto/WSP/WorkforceProfileOFOCodeSummary';


interface IProps {
    showModal: boolean;
    closeModal: () => void;
    title: string;
    ofoCodeCategoryId: number;
    ofoCodeYear: string;
    scorecardId: string;
}

export const WorkforceProfileOFOCodeSummaryModal = (props: IProps) => {
    const [data, setData] = React.useState<WorkforceProfileOFOCodeSummary[]>([]);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [filteredItemsCount, setFilteredItemsCount] = React.useState(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState(0);
    const [searchValue, setSearchValue] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);

    useEffect(() => {
        if (props.ofoCodeCategoryId > 0 && !isNullOrEmpty(props.ofoCodeYear)) {
            fetchData();
        }
    }, [props.ofoCodeCategoryId, props.ofoCodeYear, searchValue, entriesPerPage, pageNumber]);

    const searchInput : WorkforceProfileOFOCodeSearchInput = {
        categoryId: props.ofoCodeCategoryId!,
        ofoCodeYear: props.ofoCodeYear!,
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        scorecardId: props.scorecardId,
        searchValue: searchValue
    }

    const fetchData = async () => {
        setIsLoading(true);
        try{
            const response = await WSPDashboardService.SearchWorkforceProfileOFOCodeSummary(searchInput);
            setData(response.data.results);
            setTotalItemsCount(response.data.totalItemsCount);
            setFilteredItemsCount(response.data.filteredItemsCount);
        }catch(error){
            console.log(error);
        }finally{
            setIsLoading(false);
        }
    }
    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    };

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    };

    const entriesPerPageChanged = (entries: number) => {
        setEntriesPerPage({ defaultValue: entries });
        setPageNumber(1);
    };

    const tableData = WorkforceProfileOFOCodeTableMapper(data);

    return (
        <>
            <Dialog open={props.showModal} onClose={() => props.closeModal()} aria-labelledby="form-dialog-title" maxWidth={false} sx={{ minWidth: "1400px" }}>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => props.closeModal()}>
                    OFO Codes in {props.title}
                </CustomDialogTitle>
                <DialogContent>
                    <Box width="1400px">
                        <DataTable
                            table={tableData}
                            entriesPerPage={entriesPerPage}
                            entriesPerPageChanged={entriesPerPageChanged}
                            pageNumber={pageNumber}
                            pageNumberChanged={pageNumberChanged}
                            searchValueChanged={searchValueChanged}
                            filteredItemsCount={filteredItemsCount}
                            totalItemsCount={totalItemsCount}
                            isLoading={isLoading}
                            canSearch={true}
                        />
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}
